<template>
    <common-page>
        <query-config></query-config>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryConfig from "@/components/jsc/QueryConfig.vue";

export default {
    name: "QCPage",
    components: {QueryConfig, CommonPage}
}
</script>

<style scoped>

</style>
